import { defineMessages } from 'react-intl';

export default defineMessages({
  mfTotpPrompt: {
    id: 'mf.totp.prompt',
    defaultMessage: 'Enter the code from your authenticator app.',
    description:
      'Message shown on the 2SV challenge screen to prompt the user to enter the code from their authenticator app',
  },
  mfSmsPrompt: {
    id: 'mf.sms.prompt',
    defaultMessage: 'Enter the code you received by SMS.',
    description:
      'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their SMS',
  },
  mfEmailPrompt: {
    id: 'mf.email.prompt',
    defaultMessage: 'Enter the code from your email.',
    description:
      'Message shown on the 2SV challenge screen to prompt the user to enter the code sent to their email',
  },
});
